import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  onClose(): void;
  onOutside?: boolean;
}

const ModalClose: React.FC<Props> = ({ onClose, onOutside = false }) => {
  return (
    <IconButton
      color="primary"
      sx={{
        position: 'absolute',
        top: onOutside ? -35 : 0,
        right: onOutside ? -60 : 0,
        margin: 0.5,
        padding: 2,
        zIndex: 50000,
        ...(onOutside
          ? {
              color: '#fff',
            }
          : {}),
      }}
      onClick={onClose}
      size="large"
    >
      <CloseIcon />
    </IconButton>
  );
};

export default ModalClose;
